import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './useBuybackCategories.translations'

export interface BuybackCategory {
  name: string
  label: string
  image: string
}

export function useBuybackCategories() {
  const i18n = useI18n()

  const categories = computed<BuybackCategory[]>(() => [
    {
      name: 'iphone',
      label: i18n(translations.categoryIphone),
      image: '/img/buyback/pp/category-iphone.png',
    },
    {
      name: 'smartphone',
      label: i18n(translations.categorySmartphone),
      image: '/img/buyback/pp/category-smartphone.png',
    },
    {
      name: 'tablet',
      label: i18n(translations.categoryTablet),
      image: '/img/buyback/pp/category-tablet.png',
    },
    {
      name: 'macbook',
      label: i18n(translations.categoryMacbook),
      image: '/img/buyback/pp/category-macbook.png',
    },
    {
      name: 'gaming_console',
      label: i18n(translations.categoryGamingConsole),
      image: '/img/buyback/pp/category-gaming.png',
    },
    {
      name: 'audio',
      label: i18n(translations.categoryAudio),
      image: '/img/buyback/pp/category-audio.png',
    },
  ])

  function getLinkByCategory(categoryName: string) {
    switch (categoryName) {
      case 'iphone':
        return {
          name: 'buyback_device_form',
          params: { slug: 'smartphone', id: 'smartphone' },
          query: { nextStep: 'false', brand: 'Apple' },
        }

      default:
        return {
          name: 'buyback_device_form',
          params: { slug: categoryName, id: categoryName },
          query: { nextStep: 'false' },
        }
    }
  }

  function getTitleByCategory(categoryName: string) {
    switch (categoryName) {
      case 'Apple':
        return i18n(translations.categoryIphone)
      case 'smartphone':
        return i18n(translations.categorySmartphone)
      case 'tablet':
        return i18n(translations.categoryTablet)
      case 'macbook':
        return i18n(translations.categoryMacbook)
      case 'gaming_console':
        return i18n(translations.categoryGamingConsole)
      case 'audio':
        return i18n(translations.categoryAudio)
      default:
        return ''
    }
  }

  return {
    categories,
    getLinkByCategory,
    getTitleByCategory,
  }
}
